import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next"; // Dodajte ovo za korišćenje useTranslation hook-a

const Lessons = () => {
  const { educationItemsList } = useSelector((state) => state.educationReducer);

  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation(); // Koristite useTranslation za prevođenje

  // Ako `educationItemsList` nije učitan, preusmeravamo korisnika
  useEffect(() => {
    if (!educationItemsList || !educationItemsList.lessons) {
      navigate("/education-list");
    }
  }, [educationItemsList, navigate]);

  // Provera da li `educationItemsList` ima validne podatke
  if (!educationItemsList || !educationItemsList.lessons) {
    return null;
  }

  const handleNext = () => {
    if (activeStep < educationItemsList?.lessons?.length - 1) {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const handleStartTest = () => {
    navigate("/questions"); // Preusmeravanje na stranicu sa pitanjima
  };

  return (
    <div className="education-lesson-main-content">
      {/* Sadržaj koraka */}
      <div className="education-lesson-content">
        <div className="education-lesson-content-text-title">
          {educationItemsList?.lessons[activeStep]?.name}
        </div>
        <div className="education-lesson-content-image">
          <img
            src={educationItemsList?.lessons[activeStep]?.image}
            className="img-fluid"
          />
        </div>
        <div className="education-lesson-content-text">
          <div
            className="education-lesson-content-text-description"
            dangerouslySetInnerHTML={{
              __html: educationItemsList?.lessons[activeStep]?.description,
            }}
          ></div>
        </div>
      </div>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingTop: 3,
          marginBottom: 15,
          gap: 2,
        }}
      >
        {activeStep < educationItemsList?.lessons?.length - 1 && (
          <Button
            className="next-step-lesson-button w-100"
            onClick={handleNext}
          >
            {t("lessons.nextLesson")}
          </Button>
        )}

        {activeStep === educationItemsList?.lessons?.length - 1 && (
          <Button className="start-quiz-button" onClick={handleStartTest}>
            {t("lessons.startTest")}
          </Button>
        )}
        {activeStep > 0 && (
          <Button className="prev-step-lesson-button" onClick={handleBack}>
            {t("lessons.previousLesson")}
          </Button>
        )}
      </Box>
    </div>
  );
};

export default Lessons;
